<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.purchases.retrieveLoader">
      <v-boilerplate type="table-heading, list-item-two-line" />
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="table" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <v-row align="center" justify="start" no-gutters>
              <router-link :to="{ name: 'BillersBuiltInSettings' }" class="subtitle-1 routerLink font-weight-medium">Facturación incorporada</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <router-link class="subtitle-1 routerLink font-weight-medium" :to="{name: 'PurchaseList'}">Compras</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <span class="subtitle-1 font-weight-medium d-inline-block text-truncate" :style="$vuetify.breakpoint.width < 1200 ? 'max-width: 350px;' : 'max-width: 500px;'">{{((instance || {}).document || {}).name}} de {{((instance || {}).supplier || {}).name}}</span>
            </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn v-if="instance.document.is_purshase && !instance.document.is_sale" class="ml-1" @click="renderDocument('purchases')" outlined color="secondary" retain-focus-on-click><v-icon small left>mdi-file-document</v-icon>PDF</v-btn>
              <template v-else>
                <v-btn @click="renderDocument('purchases', 'billers/built_in/swaps', 'pdf', swap.id)" v-if="swap" outlined color="secondary" retain-focus-on-click><v-icon small left>mdi-file-document </v-icon> PDF</v-btn>
              </template>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <v-row class="mx-0 background">
            <v-col cols="2">
              <span class="d-block mb-1">Total</span>
              <span class="body-1 font-weight-medium mr-1">{{instance.total | currency(instance.currency)}}</span>
              <span>{{instance.currency}}</span>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="3" class="ml-2">
              <span class="d-block mb-1">Proveedor</span>
              <v-btn :to="{name:'SupplierRetrieveUpdate', params:{id: instance.supplier.id}}" height="20" text color="primary" retain-focus-on-click :ripple="false">
                <span class="d-inline-block text-truncate" style="max-width: 200px;">{{((instance || {}).supplier || {}).name}}</span>
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col cols="2" class="ml-2">
              <span class="d-block mb-1">Fecha</span>
              <div class="font-weight-medium mt-1">{{instance.date | date}}</div>
            </v-col>
          </v-row>
          <v-divider />
          <v-toolbar class="transparent" flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Información general</v-toolbar-title>
          </v-toolbar>
          <v-row>
            <v-col cols="5">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Tipo de documento</v-list-item-title>
                  <v-list-item-subtitle>{{((instance || {}).document || {}).name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Número</v-list-item-title>
                  <v-list-item-subtitle>{{instance.number}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Creado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.created | dateTime}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- SII management -->
      <v-card class="px-0 my-5" v-if="account.country.id == 'CL' && instance.document.has_local_format">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Gestión SII</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="mr-1" @click="modalSwap=true" v-if="swap && !swap.status" outlined color="secondary">Aceptar o rechazar</v-btn>
              <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" retain-focus-on-click outlined color="secondary">Opciones</v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-5 py-1" v-if="swap && swap.local_file" :href="swap.local_file" target="_blank" :ripple="false">
                    <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">Ver XML</v-list-item-title>
                  </v-list-item>
                  <v-list-item class="px-5 py-1" v-else-if="instance.local_file" :href="instance.local_file" target="_blank" :ripple="false">
                    <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">Ver XML</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <template v-if="swap">
            <v-row>
              <v-col>
              <v-list class="v-list-form-extended transparent">
                <v-list-item>
                  <v-list-item-title>Estado</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-chip v-if="!swap.status" class="caption" color="defaultGrey" text-color="secondary" small>Pendiente</v-chip>
                    <v-chip v-else-if="swap.status === 'ERM'" color="lightBlue" text-color="primary" small>Aceptado<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                    <v-chip v-else-if="swap.status === 'ACD'" color="lightBlue" text-color="primary" small>Aceptado<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                    <v-chip v-else-if="swap.status === 'RCD'" class="caption" color="defaultGrey" text-color="secondary" small>Rechazado<v-icon class="ml-1" x-small>mdi-close</v-icon></v-chip>
                    <v-chip v-else-if="swap.status === 'RFP'" class="caption" color="defaultGrey" text-color="secondary" small>Rechazado<v-icon class="ml-1" x-small>mdi-close</v-icon></v-chip>
                    <v-chip v-else-if="swap.status === 'RFT'" class="caption" color="defaultGrey" text-color="secondary" small>Rechazado<v-icon class="ml-1" x-small>mdi-close</v-icon></v-chip>
                  </v-list-item-subtitle>
                </v-list-item>
                <template v-if="swap.status">
                  <v-list-item>
                    <v-list-item-title>Detalle del estado</v-list-item-title>
                    <v-list-item-subtitle>
                      <span v-if="swap.status === 'ERM'">Otorga recibo de mercaderías o servicios</span>
                      <span v-else-if="swap.status === 'ACD'">Acepta contenido del documento</span>
                      <span v-else-if="swap.status === 'RCD'">Reclamo al contenido del documento</span>
                      <span v-else-if="swap.status === 'RFP'">Reclamo por falta parcial de mercaderías</span>
                      <span v-else-if="swap.status === 'RFT'">Reclamo por falta total de mercaderías</span>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Archivos de respuesta</v-list-item-title>
                    <v-list-item-subtitle class="text-left">
                      <v-btn class="mr-1" :href="swap.reception" target="_blank" v-if="swap.reception" outlined color="secondary" small>Recepción</v-btn>
                      <v-btn class="mr-1" :href="swap.receipt" target="_blank" v-if="swap.receipt" outlined color="secondary" small>Recepción</v-btn>
                      <v-btn class="mr-1" :href="swap.result" target="_blank" v-if="swap.result" outlined color="secondary" small>Resultado</v-btn>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Respondido el</v-list-item-title>
                    <v-list-item-subtitle>{{swap.reply_date | dateTime}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Respondido por</v-list-item-title>
                    <v-list-item-subtitle>{{swap.reply_by}}</v-list-item-subtitle>
                  </v-list-item>
                </template>
                <v-list-item>
                  <v-list-item-title v-if="swap.status">Respondido a</v-list-item-title>
                  <v-list-item-title v-else>Responder a</v-list-item-title>
                  <v-list-item-subtitle>{{swap.reply_to}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-list class="v-list-form-extended transparent py-5">
              <v-list-item>
                <v-list-item-title>Estado</v-list-item-title>
                <v-list-item-subtitle>
                  <v-btn v-if="!instance.tax_agency.cl_status" @click="taxAgencyService('purchases', 'purchases', 'tax_agency_status')" :loading="taxAgencyLoader" text color="primary" :ripple="false">Actualizar estado</v-btn>
                  <v-chip v-else-if="instance.tax_agency.cl_status.includes('Rechazado')" class="caption" color="defaultGrey" text-color="secondary" small>{{instance.tax_agency.cl_status}}<v-icon class="ml-1" x-small>mdi-close</v-icon></v-chip>
                  <v-chip v-else color="lightBlue" text-color="primary" small>{{instance.tax_agency.cl_status}}<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item v-if="instance.tax_agency.cl_status_detail">
                <v-list-item-title>Detalle del estado</v-list-item-title>
                <v-list-item-subtitle>{{instance.tax_agency.cl_status_detail}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  Track ID
                  <v-tooltip v-if="!instance.tax_agency.cl_id" right transition="scale-transition">
                    <template v-slot:activator="{on}">
                      <v-icon v-on="on" small color="red">mdi-alert</v-icon>
                    </template>
                    <span>Es requerido enviar a la agencia fiscal</span>
                  </v-tooltip>
                </v-list-item-title>
                <v-list-item-subtitle class="text-left">
                  <span v-if="instance.tax_agency.cl_id">{{instance.tax_agency.cl_id}}</span>
                  <span v-else><v-btn @click="taxAgencyService('purchases', 'purchases', 'tax_agency_send')" :loading="taxAgencyLoader" text color="primary" :ripple="false">Enviar a la agencia fiscal</v-btn></span>
                </v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </template>
        </v-card-text>
      </v-card>
      <!-- end SII management -->

      <v-card class="pa-0 my-5">
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Productos</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Producto</th>
                  <th class="text-center">Unidad de medida</th>
                  <th class="text-right">Cantidad</th>
                  <th class="text-right">P. unitario</th>
                  <th class="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="d in instance.lines">
                  <tr :key="d.id">
                    <td>
                      <span class="body-2 text--secondary">{{d.name}}</span>
                      <span class="d-block">{{d.description}}</span>
                    </td>
                    <td class="text-center">{{d.unit}}</td>
                    <td class="text-right">{{d.quantity | currency(instance.currency)}}</td>
                    <td class="text-right">
                      <span class="text--secondary font-weight-medium">{{d.amount | currency(instance.currency)}}</span>
                    </td>
                    <td class="text-right">
                      <span class="body-2 text--secondary font-weight-medium">{{d.total | currency(instance.currency)}}</span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider />
          <!-- summary -->
          <v-row align="center" justify="end">
            <v-col cols="4">
              <v-list class="v-list-form pa-0 transparent">
                <v-list-item class="py-1">
                  <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Exento</v-list-item-title>
                  <v-list-item-subtitle class="text-right">{{instance.exempt | number}}</v-list-item-subtitle>
                </v-list-item>
                <template v-if="instance.document.has_taxes && instance.document.has_taxes_detail">
                  <v-list-item class="py-1">
                    <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Neto</v-list-item-title>
                    <v-list-item-subtitle class="text-right">{{instance.amount | number}}</v-list-item-subtitle>
                  </v-list-item>
                    <v-list-item class="py-1">
                    <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Descuento</v-list-item-title>
                    <v-list-item-subtitle class="text-right">{{instance.discount | number}} {{instance.discount_scheme}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-divider class="ml-4 my-3" />
                  <v-list-item class="py-1">
                    <v-list-item-title class="text-left mr-2 text--secondary font-weight-medium">Impuestos ({{instance.tax_percent}}%)</v-list-item-title>
                    <v-list-item-subtitle class="text-right">{{instance.tax | number}}</v-list-item-subtitle>
                  </v-list-item>
                </template>
                <v-divider class="ml-4 my-3" />
                <v-list-item class="py-1">
                  <v-list-item-title class="text-left body-1 text--secondary font-weight-medium">Total</v-list-item-title>
                  <v-list-item-subtitle class="text-right body-1 text--secondary font-weight-medium">{{instance.total | currency(instance.currency)}} {{instance.currency}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <!-- end summary -->
        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialog swap update -->
    <v-dialog v-model="modalSwap" width="700">
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Aceptar o rechazar {{((instance || {}).document || {}).name}}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn @click="modalSwap=false" icon small retain-focus-on-click><v-icon small>mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item>
              <v-list-item-title>Respuesta</v-list-item-title>
              <v-list-item-subtitle>
                <v-select v-model="swapResponse.status" :items="swapStatuses" item-text="label" item-value="value" single-line hide-details dense outlined background-color="white" />
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="modalSwap=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="updateSwap" :loading="$store.state.billers.createLoader" color="primary">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog swap update -->

    <!-- modal pdf -->
    <v-dialog v-model="modalRender" v-if="instance.id" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">{{`PDF ${instance.document.name} Nº ${instance.number}`}}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn @click="modalRender=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row v-if="loaderRender">
            <v-col cols="12" class="py-0 ma-0">
              <v-skeleton-loader class="rounded-0" transition="fade-transition" type="table" />
            </v-col>
          </v-row>
          <v-row v-else-if="!loaderRender && !renderUrl">
            <v-col cols="12" class="py-16 text-center">
              <v-icon class="d-block" color="secondary" size="70">mdi-image-broken-variant</v-icon>
              <span class="d-block subtitle-1">PDF no disponible</span>
            </v-col>
          </v-row>
          <div id="render"></div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn :href="renderUrl" :download="`${instance.document.id}_N${instance.number}`" color="primary" dark>Descargar PDF</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end modal pdf -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import TaxAgencyViewMixin from '@/mixins/TaxAgencyViewMixin'
import RenderViewMixin from '@/mixins/RenderViewMixin'
export default {
  mixins: [
    GenericViewMixin,
    TaxAgencyViewMixin,
    RenderViewMixin
  ],
  inject: ['theme'],
  components: {
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({
    swap: null,
    swapResponse: {
      status: 'ERM'
    },
    swapStatuses: [
      { value: 'ERM', label: 'Otorga recibo de mercaderías o servicios' },
      { value: 'ACD', label: 'Acepta contenido del documento' },
      { value: 'RCD', label: 'Reclamo al contenido del documento' },
      { value: 'RFP', label: 'Reclamo por falta parcial de mercaderías' },
      { value: 'RFT', label: 'Reclamo por falta total de mercaderías' }
    ],
    modalSwap: false
  }),
  computed: mapState({
    instance: state => state.purchases.purchasesDetail
  }),
  created () {
    this.retrieve()
  },
  methods: {
    retrieve () {
      this.$store.dispatch('purchases/RETRIEVE', {
        resource: 'purchases',
        id: this.$route.params.id
      })
      .then(() => {
        if (this.instance.document.country === 'CL') {
          this.$store.dispatch('billers/LIST', {
            resource: 'billers/built_in/swaps',
            query: {
              purchases__in: this.$route.params.id
            }
          })
          .then((response) => {
            if (response.data.results) {
              this.swap = response.data.results[0]
            }
          })
        }
      })
    },
    updateSwap () {
      const accept = ['ERM', 'ACD'].includes(this.swapResponse.status)
      this.$dialog.warning({
        title: `Confirmar ${accept ? 'aceptar' : 'rechazar'} documento`,
        text: `
          <span class="d-block">Se enviará un email al proveedor y se registrará la respuesta en tu cuenta de sii.cl</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: accept ? 'primary' : 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('billers/UPDATE', {
                resource: 'billers/built_in/swaps',
                id: this.swap.id,
                payload: {
                  status: this.swapResponse.status,
                  purchase: this.instance.id
                }
              })
              .then((response) => {
                this.swap = response.data
                this.modalSwap = false
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    }
  }
}
</script>